import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, retry } from 'rxjs';
import { Category } from '../models/category.model';
import { environment } from '../../environments/environment';

export interface CreateCategoryDto {
  name: string;
  description?: string;
  isActive?: boolean;
  serviceGroupId?: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class CategoryService {
  private apiUrl = `${environment.apiUrl}/Category`;

  constructor(private http: HttpClient) { }

  getAllCategories(): Observable<Category[]> {
    return this.http.get<Category[]>(this.apiUrl).pipe(retry(2));
  }

  addCategory(category: Category): Observable<Category> {
    const createDto: CreateCategoryDto = {
      name: category.name,
      description: category.description,
      isActive: category.isActive !== undefined ? category.isActive : true,
      serviceGroupId: category.serviceGroupId || null
    };
    return this.http.post<Category>(this.apiUrl, createDto);
  }

  updateCategory(id: string, category: Category): Observable<Category> {
    return this.http.put<Category>(`${this.apiUrl}/${id}`, category);
  }
}


